import { render, staticRenderFns } from "./NewSupplierFailureCodeBtn.vue?vue&type=template&id=0f9cbf6a&scoped=true&"
import script from "./NewSupplierFailureCodeBtn.vue?vue&type=script&lang=js&"
export * from "./NewSupplierFailureCodeBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9cbf6a",
  null
  
)

export default component.exports